<script setup lang="ts">
import {
  mdiFileImageOutline,
  mdiFileOutline,
  mdiFileVideoOutline,
} from "@mdi/js";

const props = defineProps<{
  src: string;
  previewSrc: string;
  type: Nullable<string>;
}>();

const emit = defineEmits<{
  "click": [];
  "click:image": [];
}>();

// NOTE: Added `image/tif` exception, because browsers don't support showing it
const isImage = computed(
  () => props.type?.startsWith("image") && props.type !== "image/tif",
);
const isVideo = computed(() => props.type?.startsWith("video"));
</script>

<template>
  <div class="py-2 d-flex justify-center">
    <ThumbnailImage
      v-if="isImage && src && previewSrc"
      :src="src"
      :preview-src="previewSrc"
      @click="emit('click:image')"
    />
    <VIcon
      v-else-if="isImage"
      color="primary-darken-2"
      size="large"
      @click="emit('click')"
    >
      {{ mdiFileImageOutline }}
    </VIcon>
    <VIcon
      v-else-if="isVideo"
      color="primary-darken-2"
      size="large"
      @click="emit('click')"
    >
      {{ mdiFileVideoOutline }}
    </VIcon>
    <VIcon
      v-else
      color="primary-darken-2"
      size="large"
      @click="emit('click')"
    >
      {{ mdiFileOutline }}
    </VIcon>
  </div>
</template>
